import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import "./App.css";
import LabelClass from "./containers/LabelClass";
import AddExample from "./containers/AddLabelClass";
import UnityLabeler from "./containers/UnityLabeler";
import UnityConveyorBelt from "./containers/UnityConveyorBelt";
import ConfusionMatrix from "./containers/ConfusionMatrix";
import { loadMobileNetAsync } from "./redux/actions/featureExtractor";
import { loadgame } from "./redux/actions/game";

var App = function App(_ref) {
  var game = _ref.game;
  var dispatch = useDispatch();
  var labelClasses = useSelector(function (state) {
    return state.labelClasses.list;
  });
  var featureExtractor = useSelector(function (state) {
    return state.featureExtractor;
  });
  useEffect(function () {
    dispatch(loadMobileNetAsync());
    if (game.game_settings) dispatch(loadgame(game));
  }, [dispatch]);
  return _.isEmpty(featureExtractor) ? "Loading Mobilenet..." : /*#__PURE__*/React.createElement("div", {
    className: "app flex-row-container flex-justify-center"
  }, /*#__PURE__*/React.createElement(UnityConveyorBelt, null), /*#__PURE__*/React.createElement("div", {
    className: "flex-column-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container"
  }, /*#__PURE__*/React.createElement(ConfusionMatrix, null), /*#__PURE__*/React.createElement(UnityLabeler, null)), /*#__PURE__*/React.createElement("div", {
    className: "label-class flex-column-container"
  }, labelClasses.map(function (labelClass) {
    return /*#__PURE__*/React.createElement(LabelClass, {
      id: labelClass.id,
      key: labelClass.id,
      collapsed: labelClass.collapsed
    });
  }), /*#__PURE__*/React.createElement(AddExample, null))));
};

export default App;